module.exports = __webpack_public_path__ + "static/media/card-sm.878cba9f.jpg";